import styled, { css, CSSObject } from 'styled-components';

export const StyledTooltipContent = styled.div<{
  headersColorCss: CSSObject;
}>`
  .tooltip-container {
    height: 100%;
  }

  font-family: var(--font-family), Arial;

  .heading {
    display: flex;
    align-items: center;
    margin-bottom: 4px;

    &--image-container {
      width: 24px;
      height: 24px;
      margin-right: 4px;

      &__img {
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
    }

    &--text {
      text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
      font-size: 0.875rem;
      font-style: normal;
      font-weight: 800;
      line-height: normal;
      color: #ffff;

      ${(props) => css(props.headersColorCss)}
    }
  }

  .section {
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }

    &--name {
      text-shadow: 0 1px 1px rgba(0, 0, 0, 0.3);
      font-size: 0.75rem;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      color: #ffff;
      margin-bottom: 8px;

      ${(props) => css(props.headersColorCss)}
    }

    &--list {
      padding: 0;
      margin: 0;

      &__item {
        list-style: none;
        display: flex;
        align-items: center;
        margin-bottom: 4px;
        &:last-child {
          margin-bottom: 0;
        }

        .item {
          &--image-container {
            width: 24px;
            height: 24px;
            margin-right: 8px;

            &__img {
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }

          &--text {
            color: #fff;
            text-align: center;
            font-size: 14px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
          }
        }
      }
    }
  }
` as any;

export const StyledDivider = styled.div`
  border-radius: 2px;
  background: ${({ color }) => color};
  height: 2px;
  margin-bottom: 8px;
`;
